import classNames from 'classnames';
import React from 'react';
import { FCC } from 'react';
import { IContainerProps } from './types';

export const Container: FCC<IContainerProps> = (props) => {
  const { fluid = false } = props;
  const containerClasses = classNames({
    container: !fluid,
    'container-fluid': fluid,
  });
  return <div className={containerClasses}>{props.children}</div>;
};

export default Container;
